module.exports = __webpack_public_path__ + "img/cli.6bc32356.png";